import * as React from 'react';
import Stats from './Stats';
import WhyUs from './WhyUs';
import OurPlan from './OurPlan';
import {ReactComponent as LeftArrow} from '../assets/leftArrow.svg';
import {ReactComponent as RightArrow} from '../assets/rightArrow.svg';
import './Slider.css';
import { useTranslation } from 'react-i18next';

const Slider = () => {
    const { t, i18n } = useTranslation();
    const dots = [
        'stats', 'why-us', 'our-plan'
    ];
    const [currentSlide, setCurrentSlide] = React.useState<number>(0);
    const changeSlide = (id:number) => {
        const element = document.getElementById(dots[id]);
        if(element) {
            element.scrollIntoView({behavior: 'smooth', block:'nearest', inline:'center'});
        }
        setCurrentSlide(id);
    };

    return (
        <section className='slider-wrapper'>
            <div className='slides-wrapper'>
                <Stats t={t} i18n={i18n} />
                <WhyUs t={t} />
                <OurPlan t={t} />
            </div>
            {currentSlide !== 0 ? <LeftArrow className='arrow-icon arrow-left' onClick={()=>changeSlide(currentSlide-1)}/> : null}
            {currentSlide !== dots.length-1 ? <RightArrow className='arrow-icon arrow-right' onClick={()=>changeSlide(currentSlide+1)}/> : null}
            <div className='dots'>
                {dots.map((slide, idx) => (
                    <button key={idx} className='dot' onClick={()=>changeSlide(idx)}
                    style={currentSlide === idx ? {background: '#FF8E00'} : {}}></button>
                ))}
            </div>
        </section>
    )
}

export default Slider;